import { NotifyHelper } from "../../../helpers/toast";
import { objCaAnDefine } from "../../action-types/thuc-don/IFoCaAnActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const foCaAnActions = {
    ...generateActions(objCaAnDefine, "CA_AN"),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objCaAnDefine, "CA_AN",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
